<template>
  <footer class="app-footer">
    <span>{{year}} &copy; Drift Technological Solutions Ltd.</span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer', 
   data() {
    return {
      year: null
    };
  },

    created() {
      let d = new Date();
      this.year = d.getFullYear();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue